import { Box, Grid, Skeleton } from '@mui/material';
import React, { useMemo } from 'react';
import InduvidualCard from './InduvidualCard';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// export const cardColors = [
//   '#1976d2', // 1 Blue
//   '#2e7d32', // 2 Green
//   '#ed6c02', // 3 Orange
//   '#9c27b0', // 4 Purple
//   '#d32f2f', // 5 Red
//   '#0288d1', // 6 Cyan Blue
//   '#6d4c41', // 7 Brown
//   '#00897b', // 8 Teal
//   '#c2185b', // 9 Pink
//   '#7b1fa2', // 10 Deep Purple
//   '#455a64', // 11 Blue Grey
//   '#f57c00', // 12 Dark Orange
//   '#388e3c', // 13 Dark Green
//   '#5d4037', // 14 Dark Brown
//   '#0097a7', // 15 Dark Cyan
//   '#512da8', // 16 Indigo
//   '#c62828', // 17 Dark Red
//   '#00796b', // 18 Sea Green
//   '#ad1457', // 19 Rose
//   '#3949ab', // 20 Royal Blue
//   '#00838f', // 21 Aqua
//   '#afb42b', // 22 Lime
// ];

export const cardColors = [
  '#1E88E5', // 1 Blue
  '#43A047', // 2 Green
  '#FB8C00', // 3 Orange
  '#8E24AA', // 4 Purple
  '#E53935', // 5 Red
  '#00ACC1', // 6 Cyan
  '#6D4C41', // 7 Brown
  '#FDD835', // 8 Yellow
  '#D81B60', // 9 Pink
  '#3949AB', // 10 Indigo
  '#00897B', // 11 Teal
  '#F4511E', // 12 Deep Orange
  '#7CB342', // 13 Light Green
  '#5E35B1', // 14 Violet
  '#039BE5', // 15 Sky Blue
  '#C0CA33', // 16 Lime
  '#8D6E63', // 17 Light Brown
  '#E91E63', // 18 Magenta
  '#546E7A', // 19 Blue Grey
  '#FF7043', // 20 Coral
  '#26A69A', // 21 Sea Green
  '#AB47BC', // 22 Lavender
];
const cardJson = [
  {
    id: 1,
    key: 'revenue',
    name: 'Revenue',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:currency-inr',
    color: '#2e7d32',
    path: 'revenueOrExpense-details',
  },
  {
    id: 2,
    key: 'expenses',
    name: 'Expenses',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:cash-minus',
    color: '#d32f2f',
    path: 'revenueOrExpense-details',
  },
  {
    id: 3,
    key: 'totalSales',
    name: 'Total Sales',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:cart',
    color: '#9c27b0',
    path: 'sales-details',
  },
  {
    id: 4,
    key: 'retentionRate',
    name: 'Retention Rate',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-heart',
    color: '#00897b',
    path: 'retention-details',
  },
  {
    //leads
    id: 5,
    key: 'totalLeads',
    name: 'Total Leads',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
    path: 'leads-details',
  },
  {
    id: 6,
    key: 'assessmentsCompleted',
    name: 'Assessments Completed',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:clipboard-check',
    color: '#2e7d32',
    path: 'assessment-details',
  },
  {
    id: 7,
    key: 'totalStudents',
    name: 'Total Students',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:school',
    color: '#2e7d32',
    path: 'student-details',
  },
  {
    id: 8,
    key: 'activeStudents',
    name: 'Active Students',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-multiple-check',
    color: '#2e7d32',
    path: 'student-details',
  },
  {
    id: 9,
    key: 'totalTutors',
    name: 'Total Tutors',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-off',
    color: '#d32f2f',
    path: 'tutor-details',
  },
  {
    id: 10,
    key: 'activeTutors',
    name: 'Active Tutors',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
    path: 'tutor-details',
  },
  {
    id: 11,
    key: 'totalEmployees',
    name: 'Total Employees',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-group',
    color: '#1976d2',
    path: 'emp-details',
  },
  {
    id: 12,
    key: 'todayPresent',
    name: 'Today Present',
    subDetails: 'Vs Yesterday',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
    path: 'emp-details',
  },
  {
    id: 13,
    key: 'totalOGA',
    name: 'Total OGA',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-tie',
    color: '#1976d2',
    path: 'emp-details',
  },
  {
    id: 14,
    key: 'totalSOGO',
    name: 'Total SOGO',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
    path: 'emp-details',
  },
  {
    id: 15,
    key: 'totalCRO',
    name: 'Total CRO',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-tie',
    color: '#1976d2',
    path: 'emp-details',
  },
  {
    id: 16,
    key: 'totalCRM',
    name: 'Total CRM',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-tie',
    color: '#1976d2',
    path: 'emp-details',
  },

  /* {
    id: 17,
    key: 'activeOga',
    name: 'Active OGA',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
  },
  {
    id: 18,
    key: 'inactiveOga',
    name: 'Inactive OGA',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-off',
    color: '#d32f2f',
  },
  {
    id: 19,
    key: 'activeCro',
    name: 'Active CRO',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
  },
  {
    id: 20,
    key: 'inactiveCro',
    name: 'Inactive CRO',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-off',
    color: '#d32f2f',
  },
  {
    id: 21,
    key: 'activeCrm',
    name: 'Active CRM',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-check',
    color: '#2e7d32',
  },
  {
    id: 22,
    key: 'inactiveCrm',
    name: 'Inactive CRM',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-off',
    color: '#d32f2f',
     {
    id: 15,
    key: 'inActiveStudents',
    name: 'In-Active Students',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:account-off',
    color: '#d32f2f',
  },
  {
    id: 16,
    key: 'totalAssessments',
    name: 'Total Assessments',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:clipboard-text',
    color: '#0288d1',
  },
  {
    id: 17,
    key: 'assessmentPending',
    name: 'Assessment Pending',
    subDetails: 'Vs Previous Period',
    iconifyIcon: 'mdi:clipboard-clock',
    color: '#ed6c02',
  },
  }, */
];

const CardsSection = ({ fromDate, toDate }) => {
  const managementDashboard = useSelector((state) => state.dashboard.managementDashboard.data);
  const managementDashboardLoading = useSelector((state) => state.dashboard.managementDashboard.loading);

  const manipulatedCardJson = useMemo(
    () =>
      cardJson.map((v) => ({
        ...v,
        ...(managementDashboard?.[v.key] || { value: '0', trend: 0 }),
      })),
    [managementDashboard],
  );

  return (
    <Box sx={{ borderRadius: '15px' }}>
      <Grid container spacing={2}>
        {manipulatedCardJson.map((item, index) => (
          <Grid key={item.id} item xs={12} sm={6} md={4} lg={3}>
            {managementDashboardLoading ? (
              <Skeleton sx={{ minHeight: 170 }} />
            ) : (
              <Link
                style={{
                  textDecoration: 'none',
                }}
                to={{
                  pathname: `/top-management/${item?.path}`,
                  search: `?${new URLSearchParams({ name: item?.name, fromDate, toDate })}`,
                }}
              >
                <InduvidualCard item={item} color={cardColors[index]} />
              </Link>
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CardsSection;
